import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs, Breadcrumb, Section } from '../list/types';

@Component
export default class BreadcrumbsMixin extends Vue {
  public breadcrumbsLead: Breadcrumbs = [
    {
      text: 'Главная',
      to: { path: '/' },
    },
    {
      text: 'Конструктор программ',
      to: { name: 'modules' },
    },
  ];

  public routeName = 'modules';

  get breadcrumbs() {
    const list: Breadcrumbs = [...this.breadcrumbsLead];
    if (this.$options.breadcrumbsLead)
      list.push(...this.$options.breadcrumbsLead);
    if (this.sectionRoute) list.push(this.sectionRoute);
    if (this.subsectionRoute) list.push(this.subsectionRoute);
    return list;
  }

  get sectionIndex() {
    const { section } = this.$route.params;
    if (!section) return -1;
    return this.$store.state.modulesSections.findIndex(
      ({ code }: Section) => code === section,
    );
  }

  get section() {
    if (this.sectionIndex === -1) return null;
    return this.$store.state.modulesSections[this.sectionIndex];
  }

  get sectionRoute(): Breadcrumb | null {
    const { routeName, section } = this;
    if (!section) return null;

    return {
      text: section.name,
      to: {
        name: routeName,
        params: {
          section: section.code,
        },
      },
    };
  }

  get subsectionIndex() {
    const {
      section,
      $route: {
        params: { subsection },
      },
    } = this;
    if (!section || !subsection) return -1;

    const { children = [] } = section;
    return children.findIndex(({ code }: Section) => code === subsection);
  }

  get subsection() {
    if (this.subsectionIndex === -1) return null;
    return this.section.children[this.subsectionIndex];
  }

  get subsectionRoute(): Breadcrumb | null {
    const { routeName, section, subsection } = this;
    if (!section || !subsection) return null;

    return {
      text: subsection.name,
      to: {
        name: routeName,
        params: {
          section: section.code,
          subsection: subsection.code,
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/modules/mixins/breadcrumbs-mixin.ts